module.exports = __webpack_public_path__ + "assets/img/mobtmn-open.d8842d17.png";